import type {
  PersistedClient,
  Persister,
} from "@tanstack/react-query-persist-client";
import { del, get, set } from "idb-keyval";
import createFetchClient, { type Middleware } from "openapi-fetch";
import createClient from "openapi-react-query";
import type { paths } from "./openapi";

type CreateMedimoClientArgType = {
  baseUrl?: string;
  getJWT?: () => Promise<string>;
};

export const createMeidmoClient = ({
  baseUrl,
  getJWT,
}: CreateMedimoClientArgType) => {
  const middleware: Middleware = {
    async onRequest({ request }) {
      const jwt = await getJWT?.();
      if (jwt) {
        request.headers.set("Authorization", `Bearer ${jwt}`);
      }
      return request;
    },
  };
  const client = createFetchClient<paths>({
    baseUrl,
  });
  client.use(middleware);

  return client;
};

export const createMedimoClientQuery = (args: CreateMedimoClientArgType) => {
  const client = createMeidmoClient(args);
  return createClient(client);
};

export const createIDBPersister = (
  idbValidKey: IDBValidKey = "medimo-internal-api",
): Persister => {
  return {
    persistClient: async (client: PersistedClient) => {
      await set(idbValidKey, client);
    },
    restoreClient: async () => {
      return await get<PersistedClient>(idbValidKey);
    },
    removeClient: async () => {
      await del(idbValidKey);
    },
  };
};
